import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    color: var(--purple);
  }

  .perfil {
    margin-top: 95px;
    @media screen and (max-width: 767px) {
      margin-top: -70px;
    }
  }
`;

export const WrapperBtn = styled.div`
  margin-bottom: 15px;
  display: flex;
  justify-content: right;
  width: 100%;

  button {
    width: 12.5rem;
  }
  .issqn {
    margin-right: 10px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-wrap: wrap;
  padding: 25px;
  margin-left: 20px;
  background: #ebf1f4;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  .text {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 28px;
    word-break: break-word;
    color: var(--purple);
  }
  .login {
    color: var(--orange) !important;
    font-size: 50px !important;
    line-height: 50px !important;
    font-weight: bold !important;
  }

  .title {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 28px;

    color: var(--purple);
  }
`;
export const ModalWrapper = styled.div`
  width: 100%;
  text-align: center;

  .button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
  }

  p {
    justify-content: center;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 50px;
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 3rem;
  line-height: 59px;
  margin-left: 20px;
  word-break: break-all;

  color: var(--orange) !important;
`;

export const WrapperBtnAlterar = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: flex-start;
  align-self: flex-start;
  justify-content: flex-start;
  height: 100%;

  button {
    width: 250px;
  }
`;

export const WrapperContent = styled.div`
  margin-top: 40px;
`;
